module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showSgsRender) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSgsRenderGrid),
      expression: "showSgsRenderGrid"
    }],
    class: _vm.addClass
  }, [(_vm.type == 'header') ? _c('SgsRenderHeader', {
    attrs: {
      "attr": _vm.attr,
      "showHint": _vm.showHint(),
      "hintValue": _vm.getHint(),
      "label": _vm.getLabel()
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'collapse') ? _c('SgsRenderCollapse', {
    attrs: {
      "attr": _vm.attr,
      "label": _vm.getLabel()
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'text' || _vm.type == 'filterText') ? _c('SgsRenderInputText', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue,
      "rules": _vm.rules ? _vm.rules : [],
      "showHint": _vm.showHint(),
      "label": _vm.getLabel(),
      "placeholder": _vm.getPlaceholder(),
      "hintValue": _vm.getHint(),
      "moduleType": _vm.getModuleType()
    },
    on: {
      "updateFieldValue": _vm.updateField,
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'password') ? _c('SgsRenderInputPassword', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue,
      "rules": _vm.rules ? _vm.rules : [],
      "showHint": _vm.showHint(),
      "label": _vm.getLabel(),
      "placeholder": _vm.getPlaceholder(),
      "hintValue": _vm.getHint(),
      "moduleType": _vm.getModuleType()
    },
    on: {
      "updateFieldValue": _vm.updateField,
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'numeric' || _vm.type == 'filterNumeric') ? _c('SgsRenderInputNumber', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue,
      "rules": _vm.rules ? _vm.rules : [],
      "showHint": _vm.showHint(),
      "label": _vm.getLabel(),
      "hintValue": _vm.getHint(),
      "moduleType": _vm.getModuleType()
    },
    on: {
      "updateFieldValue": _vm.updateField,
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'date' || _vm.type == 'filterDate') ? _c('SgsRenderInputDate', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue,
      "rules": _vm.rules ? _vm.rules : [],
      "showHint": _vm.showHint(),
      "label": _vm.getLabel(),
      "placeholder": _vm.getPlaceholder(),
      "hintValue": _vm.getHint(),
      "moduleType": _vm.getModuleType()
    },
    on: {
      "updateFieldValue": _vm.updateField,
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'dateTime') ? _c('SgsRenderInputDateTime', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue,
      "rules": _vm.rules ? _vm.rules : [],
      "showHint": _vm.showHint(),
      "label": _vm.getLabel(),
      "placeholder": _vm.getPlaceholder(),
      "hintValue": _vm.getHint(),
      "moduleType": _vm.getModuleType()
    },
    on: {
      "updateFieldValue": _vm.updateField,
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'time') ? _c('SgsRenderInputTime', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue,
      "rules": _vm.rules ? _vm.rules : [],
      "showHint": _vm.showHint(),
      "label": _vm.getLabel(),
      "placeholder": _vm.getPlaceholder(),
      "hintValue": _vm.getHint(),
      "moduleType": _vm.getModuleType()
    },
    on: {
      "updateFieldValue": _vm.updateField,
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'textArea') ? _c('SgsRenderInputTextArea', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue,
      "rules": _vm.rules ? _vm.rules : [],
      "showHint": _vm.showHint(),
      "label": _vm.getLabel(),
      "placeholder": _vm.getPlaceholder(),
      "hintValue": _vm.getHint(),
      "moduleType": _vm.getModuleType()
    },
    on: {
      "updateFieldValue": _vm.updateField,
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'boolean') ? _c('SgsRenderInputBoolean', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue,
      "showHint": _vm.showHint(),
      "label": _vm.getLabel(),
      "placeholder": _vm.getPlaceholder(),
      "hintValue": _vm.getHint(),
      "moduleType": _vm.getModuleType()
    },
    on: {
      "updateFieldValue": _vm.updateField,
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'cpf') ? _c('SgsRenderInputCpf', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue,
      "rules": _vm.rules ? _vm.rules : [],
      "showHint": _vm.showHint(),
      "label": _vm.getLabel(),
      "placeholder": _vm.getPlaceholder(),
      "hintValue": _vm.getHint(),
      "moduleType": _vm.getModuleType()
    },
    on: {
      "updateFieldValue": _vm.updateField,
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'cnpj') ? _c('SgsRenderInputCnpj', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue,
      "rules": _vm.rules ? _vm.rules : [],
      "showHint": _vm.showHint(),
      "label": _vm.getLabel(),
      "placeholder": _vm.getPlaceholder(),
      "hintValue": _vm.getHint(),
      "moduleType": _vm.getModuleType()
    },
    on: {
      "updateFieldValue": _vm.updateField,
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'email') ? _c('SgsRenderInputEmail', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue,
      "rules": _vm.rules ? _vm.rules : [],
      "showHint": _vm.showHint(),
      "label": _vm.getLabel(),
      "placeholder": _vm.getPlaceholder(),
      "hintValue": _vm.getHint(),
      "moduleType": _vm.getModuleType()
    },
    on: {
      "updateFieldValue": _vm.updateField,
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'association' || _vm.type == 'composition') ? _c('SgsRenderInputDataWrapper', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue,
      "formIdentifier": _vm.formIdentifier,
      "rules": _vm.rules ? _vm.rules : [],
      "showHint": _vm.showHint(),
      "label": _vm.getLabel(),
      "placeholder": _vm.getPlaceholder(),
      "hintValue": _vm.getHint(),
      "moduleType": _vm.getModuleType(),
      "instance": _vm.instance,
      "disableField": _vm.attr.disableField
    },
    on: {
      "updateFieldValue": _vm.updateField,
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'phone') ? _c('SgsRenderInputPhoneNumber', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue,
      "rules": _vm.rules ? _vm.rules : [],
      "showHint": _vm.showHint(),
      "label": _vm.getLabel(),
      "placeholder": _vm.getPlaceholder(),
      "hintValue": _vm.getHint(),
      "moduleType": _vm.getModuleType()
    },
    on: {
      "updateFieldValue": _vm.updateField,
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'file') ? _c('SgsRenderFile', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue,
      "showHint": _vm.showHint(),
      "label": _vm.getLabel(),
      "placeholder": _vm.getPlaceholder(),
      "hintValue": _vm.getHint(),
      "moduleType": _vm.getModuleType(),
      "formIdentifier": _vm.formIdentifier
    },
    on: {
      "updateFieldValue": _vm.updateField
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'currency') ? _c('SgsRenderInputCurrency', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue,
      "rules": _vm.rules ? _vm.rules : [],
      "showHint": _vm.showHint(),
      "label": _vm.getLabel(),
      "placeholder": _vm.getPlaceholder(),
      "hintValue": _vm.getHint(),
      "moduleType": _vm.getModuleType()
    },
    on: {
      "updateFieldValue": _vm.updateField,
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'image') ? _c('SgsRenderImage', {
    attrs: {
      "attr": _vm.attr
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'hidden') ? _c('SgsRenderInputHidden', {
    attrs: {
      "attr": _vm.attr
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'dashboard') ? _c('SgsRenderDashboard', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue
    },
    on: {
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'label') ? _c('SgsRenderLabel', {
    attrs: {
      "attr": _vm.attr,
      "showHint": _vm.showHint(),
      "hintValue": _vm.getHint(),
      "label": _vm.getLabel(),
      "fieldValue": _vm.fieldValue
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'grid') ? _c('SgsRenderGrid', {
    attrs: {
      "attr": _vm.attr,
      "formIdentifier": _vm.formIdentifier,
      "instance": _vm.instance,
      "fieldValue": _vm.fieldValue
    },
    on: {
      "actionLinkSelected": _vm.actionLinkSelected
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'map') ? _c('SgsRenderMap', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue,
      "rules": _vm.rules ? _vm.rules : [],
      "showHint": _vm.showHint(),
      "label": _vm.getLabel(),
      "hintValue": _vm.getHint(),
      "moduleType": _vm.getModuleType()
    },
    on: {
      "updateFieldValue": _vm.updateField,
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'dealership') ? _c('SgsRenderInputDealership', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue,
      "rules": _vm.rules ? _vm.rules : [],
      "showHint": _vm.showHint(),
      "label": _vm.getLabel(),
      "placeholder": _vm.getPlaceholder(),
      "hintValue": _vm.getHint(),
      "moduleType": _vm.getModuleType()
    },
    on: {
      "updateFieldValue": _vm.updateField,
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'charges') ? _c('SgsRenderInputCharges', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue,
      "rules": _vm.rules ? _vm.rules : [],
      "showHint": _vm.showHint(),
      "label": _vm.getLabel(),
      "placeholder": _vm.getPlaceholder(),
      "hintValue": _vm.getHint(),
      "moduleType": _vm.getModuleType()
    },
    on: {
      "updateFieldValue": _vm.updateField,
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'buttonReport') ? _c('SgsRenderButtonReport', {
    attrs: {
      "attr": _vm.attr,
      "instance": _vm.instance,
      "formIdentifier": _vm.formIdentifier,
      "label": _vm.getLabel()
    },
    on: {
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'inputCSV') ? _c('SgsRenderInputCsv', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue,
      "rules": _vm.rules ? _vm.rules : [],
      "showHint": _vm.showHint(),
      "label": _vm.getLabel(),
      "hintValue": _vm.getHint(),
      "moduleType": _vm.getModuleType()
    },
    on: {
      "updateFieldValue": _vm.updateField,
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'textEditor') ? _c('SgsRenderTextEditor', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue,
      "rules": _vm.rules ? _vm.rules : [],
      "showHint": _vm.showHint(),
      "label": _vm.getLabel(),
      "hintValue": _vm.getHint(),
      "moduleType": _vm.getModuleType()
    },
    on: {
      "updateFieldValue": _vm.updateField,
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'float') ? _c('SgsRenderFloat', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue,
      "rules": _vm.rules ? _vm.rules : [],
      "showHint": _vm.showHint(),
      "label": _vm.getLabel(),
      "placeholder": _vm.getPlaceholder(),
      "hintValue": _vm.getHint(),
      "moduleType": _vm.getModuleType()
    },
    on: {
      "updateFieldValue": _vm.updateField
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'buttonForm') ? _c('SgsRenderButtonForm', {
    attrs: {
      "label": _vm.getLabel(),
      "attr": _vm.attr,
      "formId": _vm.attr.formId,
      "instance": _vm.instance
    },
    on: {
      "actionLinkSelected": _vm.actionLinkSelected
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'buttonPrint') ? _c('SgsRenderButtonPrint', {
    attrs: {
      "attr": _vm.attr,
      "label": _vm.getLabel()
    },
    on: {
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'buttonPDF') ? _c('SgsRenderButtonPDF', {
    attrs: {
      "attr": _vm.attr,
      "label": _vm.getLabel(),
      "instance": _vm.instance
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'filterBoolean') ? _c('SgsRenderFilterBoolean', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue,
      "rules": _vm.rules ? _vm.rules : [],
      "showHint": _vm.showHint(),
      "label": _vm.getLabel(),
      "placeholder": _vm.getPlaceholder(),
      "hintValue": _vm.getHint(),
      "moduleType": _vm.getModuleType()
    },
    on: {
      "updateFieldValue": _vm.updateField
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'button') ? _c('SgsRenderButton', {
    attrs: {
      "attr": _vm.attr,
      "label": _vm.getLabel()
    },
    on: {
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'errorList') ? _c('SgsRenderErrorList', {
    attrs: {
      "fieldValue": _vm.fieldValue
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'select') ? _c('SgsRenderInputSelect', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue
    },
    on: {
      "updateFieldValue": _vm.updateField
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'multiSelect') ? _c('SgsRenderInputMultiSelect', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue
    },
    on: {
      "updateFieldValue": _vm.updateField
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'upload') ? _c('SgsRenderInputButtonUpload', {
    attrs: {
      "attr": _vm.attr,
      "fieldValue": _vm.fieldValue
    },
    on: {
      "updateFieldValue": _vm.updateField
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'customComponent') ? _c('SgsRenderCustomComponent', {
    attrs: {
      "attr": _vm.attr,
      "instance": _vm.instance,
      "formIdentifier": _vm.formIdentifier
    },
    on: {
      "callBusinessRule": _vm.callBusinessRule
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-262c79fa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/sgs/SgsRender.vue
// module id = 900
// module chunks = 2